import { useState } from 'react'

import { FlexBox } from '../../../components/Base/FlexBox'
import { Button } from '../../../components/Button/Button'
import { InlineSpinner } from '../../../components/Spinner'
import { Text } from '../../../components/Text/Text'
import { useDeviceVersions } from '../../../hooks/query/useDeviceVersios'
import { DeviceVersion, User } from '../../../models/user'

interface ProfileDeviceVersionsProps {
  user: User
}

export function ProfileDeviceVersions({ user }: ProfileDeviceVersionsProps) {
  const { deviceVersions, isLoading } = useDeviceVersions(user.id)
  const [showAllDeviceVersions, setShowAllDeviceVersions] = useState(false)

  if (isLoading)
    return (
      <FlexBox alignItems="flex-start" justifyContent="flex-start">
        <InlineSpinner size="1em" />
      </FlexBox>
    )

  const [lastestDeviceVersion, ...restDeviceVersions] = deviceVersions || []

  function renderDeviceVersion(deviceVersion: DeviceVersion) {
    return (
      <Text variant="label3" key={JSON.stringify(deviceVersion)}>
        {new Date(deviceVersion.timestamp).toLocaleString('en', {
          year: '2-digit',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        })}
        :{' '}
        {[
          deviceVersion.deviceModel,
          deviceVersion.appVersion,
          deviceVersion.deviceType,
          deviceVersion.osVersion,
        ].join(' ')}
      </Text>
    )
  }

  return (
    <>
      <div>{lastestDeviceVersion && renderDeviceVersion(lastestDeviceVersion)}</div>
      <div style={{ display: showAllDeviceVersions ? 'block' : 'none' }}>
        {restDeviceVersions.map(renderDeviceVersion)}
      </div>
      {!showAllDeviceVersions && restDeviceVersions.length ? (
        <Button variant="text" size="small" onClick={() => setShowAllDeviceVersions(!showAllDeviceVersions)}>
          and {restDeviceVersions.length} more
        </Button>
      ) : null}
    </>
  )
}
